export default class PricingPredictionResponse {

    constructor({price, similarProperties, propertyData}) {
        this.price = price;
        this.similarProperties = similarProperties;
        this.propertyData = propertyData;
    }
  }
  


// WEBPACK FOOTER //
// ./src/pricing/vo/PricingPredictionResponse.js